import { PALETTE as P } from "../../tokens";

/**
 * FoundationsMulti — "Multi-Select" (pick up to `max`).
 *
 * Tap to select, tap again to deselect. Once `max` is reached, the
 * unselected options dim and become non-interactive until something is
 * deselected.
 *
 * Props:
 *   options  — [{ value, label }]
 *   max      — maximum selectable
 *   onSelect — (selectedArray) => void
 *   selected — array of selected values
 */
export default function FoundationsMulti({ options = [], max = 2, onSelect, selected = [] }) {
  const atMax = selected.length >= max;

  const toggle = (value) => {
    if (selected.includes(value)) {
      onSelect(selected.filter((v) => v !== value));
    } else if (!atMax) {
      onSelect([...selected, value]);
    }
  };

  return (
    <div>
      <div
        style={{
          fontSize: 12,
          color: P.textMute,
          marginBottom: 12,
        }}
      >
        Pick up to {max} · {selected.length}/{max} selected
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {options.map((opt) => {
          const isSelected = selected.includes(opt.value);
          const disabled = !isSelected && atMax;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => toggle(opt.value)}
              disabled={disabled}
              style={{
                width: "100%",
                textAlign: "left",
                padding: "15px 16px",
                borderRadius: 12,
                border: isSelected
                  ? `1.5px solid ${P.primary}`
                  : `1px solid ${P.border}`,
                background: isSelected ? P.primarySoft : P.bg,
                color: isSelected ? P.primary : P.text,
                fontSize: 14,
                lineHeight: 1.45,
                fontWeight: isSelected ? 600 : 400,
                cursor: disabled ? "default" : "pointer",
                opacity: disabled ? 0.4 : 1,
                transition: "all 0.15s ease",
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
